import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../App';
import { LoadingFull, LoadingOverlay } from '../loading';
import Modal from './myBooks/modal';
import { BsThreeDots } from "react-icons/bs";

export const MyBooks = () => {

  const [myBooks, setMyBooks] = useState();
  const [selected, setSelected] = useState();
  const [showModal, setShowModal] = useState(false);
  const [thumbLoaded, setThumbLoaded] = useState(false)
  const [selectedImage, setSelectedImage] = useState(0)
  const [load, setLoad] = useState(false);
  const [type, setType] = useState(0)
  const navigate = useNavigate()
  const token = localStorage.getItem('token')

  useEffect(() => {
    if (!showModal) {
      setThumbLoaded(false)
    }
  }, [showModal])
  
  const deleteBook = (dbId) => {
    setLoad(dbId)
    axios({
        method: 'post',
        url: '/api/deleteMyBook',
        data: {
            'dbId': dbId
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
      setShowModal(false)
      setSelected()
      setLoad(false)
      setMyBooks(response.data)
    })
    .catch(error => {
      setLoad(false)
      console.log(error);
    });
  }

  useEffect(() => {
    if (typeof myBooks === 'undefined') {
        axios({
            method: 'post',
            url: '/api/myBooks',
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(response => {
            setMyBooks(response.data)
        })
        .catch(error => {
            console.log(error);
        });
    }
  }, []);

  return (
    <div class="relative h-full flex flex-col gap-4">
        {(typeof myBooks === 'undefined') ?
            <LoadingFull />
        :
            <>
                <div className="boughtOrSold flex gap-2 select-none text-sm">
                    <div onClick={() => (type !== 0) ? setType(0) : ""} className={"px-4 py-2 border border-emerald-600" + (type === 0 ? " bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 text-white" : " cursor-pointer")}>Alle <span className="font-medium">({myBooks.length})</span></div>
                    <div onClick={() => (type !== 1) ? setType(1) : ""} className={"px-4 py-2 border border-emerald-600" + (type === 1 ? " bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 text-white" : " cursor-pointer")}>Aktiv <span className="font-medium">({myBooks.filter(a => !a.sold).length})</span></div>
                    <div onClick={() => (type !== 2) ? setType(2) : ""} className={"px-4 py-2 border border-emerald-600" + (type === 2 ? " bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 text-white" : " cursor-pointer")}>Solgt <span className="font-medium">({myBooks.filter(a => a.sold).length})</span></div>
                </div>
                {(myBooks.filter(book => {
                        if (type === 1 && book.sold) return false;
                        if (type === 2 && !book.sold) return false;
                        return true;
                    }).length > 0) ?
                    myBooks.filter(book => {
                        if (type === 1 && book.sold) return false;
                        if (type === 2 && !book.sold) return false;
                        return true;
                    }).map((data) => (
                        <div className="flex items-center shadow-lg flex-wrap gap-x-12 gap-y-5 justify-between p-5 relative">
                            {(load === data.dbBook._id) ?
                              <LoadingOverlay />
                            :
                              ""}
                            <div className="flex flex-col sm:flex-row gap-5 w-full sm:w-auto flex-[1]">
                                <div className="h-auto w-full sm:w-fit content-center bg-neutral-100">
                                    <div className="bookImage aspect-square mx-auto w-28 h-auto bg-neutral-100 p-2">
                                        <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${data.dbBook['_id']}%2F0?alt=media&t=${new Date().getTime()}`} alt='BOOK' className="h-full w-full object-contain bg-neutral-100" />
                                    </div>
                                </div>
                                <div className="bookInfo flex-[2] justify-center flex flex-col gap-2 mr-auto sm:mr-0">
                                    <div className="flex gap-2 flex-wrap font-medium">
                                        {data.dbBook.sold ?
                                            <div className="text-sm bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 w-fit py-1 px-2 text-white">
                                                Solgt
                                            </div>
                                        :
                                            <div className="text-sm bg-emerald-100 bg-pos-0 bg-size-200 w-fit py-1 px-2 text-emerald-800">
                                                Aktiv
                                            </div>}
                                    </div>
                                    <div className="praktisk flex flex-col gap-2">
                                        <div className="title">
                                            <h1 className="text-sm xl:text-base font-semibold">{data.apiBook.title}</h1>
                                            <p className="text-sm xl:text-base text-gray-700 font-medium">{data.apiBook.version}</p>
                                        </div>
                                        <div className="info flex gap-x-5 gap-y-2 flex-wrap">
                                            <div className="price flex flex-col">
                                                <h2 className="text-sm">Pris</h2>
                                                <h2 className="font-medium">{Number(data.dbBook.price/100).toFixed(2).replace(/\./g, ',')} kr.</h2>
                                            </div>
                                            {((data.dbBook.sold)) ?
                                                <div className="price flex flex-col">
                                                    <h2 className="text-sm">Status</h2>
                                                    <h2 className="font-medium">{data.soldBook.orderStatus === 0 ? (data.soldBook.deliveryType === 3 ? "Afhentes af køber" : "Ikke afsendt") : data.soldBook.orderStatus === 1 ? "Afsendt" : data.soldBook.orderStatus === 2 ? "Leveret" : data.soldBook.orderStatus === 3 ? "Afsluttet" : "Annulleret"}</h2>
                                                </div>
                                            :
                                                ""
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="py-2 w-full lg:mr-10 lg:w-48 border border-emerald-600 text-center hover:bg-emerald-600 hover:text-white transition-[] cursor-pointer sm:hidden" onClick={() => data.dbBook.sold ? navigate(`/dashboard/ordre?id=${data.soldBook.dbShipment}`) : setSelected(data) & setShowModal(true)}>
                                Se detaljer
                            </div>

                            <div className="buttons gap-5 text-sm font-medium flex-wrap items-center hidden sm:flex">
                              {!data.dbBook.sold ?
                                <>
                                  <div className={"border border-emerald-600 px-4 py-1 transition-[] hidden md:block" + (data.dbBook.sold ? " opacity-50 select-none" : " cursor-pointer hover:bg-emerald-600 hover:text-white")} onClick={() => !data.dbBook.sold ? navigate(`/dashboard/editBook?book=${data.dbBook._id}`) : ""}>Rediger</div>
                                  <div className={"border border-emerald-600 px-4 py-1 transition-[] hidden xl:block" + (data.dbBook.sold ? " opacity-50 select-none" : " cursor-pointer hover:bg-emerald-600 hover:text-white")} onClick={() => !data.dbBook.sold ? deleteBook(data.dbBook._id) : ""}>Slet</div>
                                </>
                              :
                                <div className="border border-emerald-600 px-4 py-1 cursor-pointer hover:bg-emerald-600 hover:text-white transition-[] hidden md:block" onClick={() => data.dbBook.sold ? navigate(`/dashboard/ordre?id=${data.soldBook.dbShipment}`) : ""}>Detaljer</div>}
                              <BsThreeDots size="25px" className="cursor-pointer" onClick={() => setSelected(data) & setShowModal(true)} />
                            </div>
                        </div>
                    ))
                :
                    "Du har ingen" + (type === 0 ? " bøger til salg" : type === 1 ? " aktive bøger" : " solgte bøger")}
            </>
        }
        <Modal open={showModal} onClose={() => setShowModal(false)}>
            {(load) ?
                <LoadingOverlay />
            :
                ""
            }
            {(typeof selected !== 'undefined') ?
              <div className="overflow-y-scroll h-full w-full">
                <div className="flex flex-col md:flex-row gap-5 w-full md:w-auto flex-[1] p-6 py-10">
                    <div className="bookImage flex-[1] flex flex-col gap-5">
                        <div className="w-full relative bg-neutral-100 p-5">
                            {(!thumbLoaded) ?
                                <div className="top-0 left-0 absolute w-full h-full">
                                <LoadingFull />
                                </div>
                            :
                                ""}
                            <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${selected.dbBook['_id']}%2F${selectedImage}?alt=media&t=${new Date().getTime()}`} alt="BOOK" className="object-contain w-full h-36 sm:h-48 md:h-56 lg:h-72 xl:h-96" style={{"max-height": "-webkit-fill-available"}} onLoad={() => setThumbLoaded(true)} loading="eager" />
                        </div>
                        <div className={`gallery grid grid-cols-5 sm:grid-cols-8 md:grid-cols-3 lg:grid-cols-5 flex-row w-full gap-2 h-fit`}>
                            {Array.from({ length: selected.dbBook['images'] }).map((_, index) => {
                                return (
                                    <div className={"cursor-pointer content-center p-2 bg-neutral-100 " + (selectedImage === index ? " ring-2 ring-emerald-500" : "")} onClick={() => setSelectedImage(index)}>
                                        <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${selected.dbBook['_id']}%2F${index}?alt=media&t=${new Date().getTime()}`} alt="BOOK" className={"w-full h-auto"} loading="eager" />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="bookInfo flex-[2] flex flex-col gap-5">
                      <div className="flex gap-2 flex-wrap font-medium">
                          {selected.dbBook.sold ?
                              <div className="text-sm bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 w-fit py-1 px-2 text-white">
                                  Solgt
                              </div>
                          :
                              <div className="text-sm bg-emerald-100 bg-pos-0 bg-size-200 w-fit py-1 px-2 text-emerald-800">
                                  Aktiv
                              </div>}
                      </div>
                      <div className="praktisk flex flex-col gap-5">
                          <div className="title space-y-2">
                              <h1 className="text-xl lg:text-2xl font-semibold">{selected.apiBook.title}</h1>
                              <p className="text-base lg:text-lg text-gray-700">
                                  {selected.apiBook.director.length > 0 ?
                                      <span className="">
                                          {selected.apiBook.director.map((dir, index) => {
                                          if (index !== 0) {
                                              return `, ${dir['$']}`
                                          } else {
                                              return ` ${dir['$']}`
                                          }
                                          })}
                                      </span>
                                  :
                                      "Ukendt forfatter"}
                              </p>
                          </div>
                          <div className="description flex flex-col gap-2">
                              <p className="text-sm lg:text-base text-gray-700 font-medium">ISBN:
                                  <span className="font-normal"> {selected.apiBook.isbn}</span>
                              </p>
                              <p className="text-sm lg:text-base text-gray-700 font-medium">Udgave:
                                  <span className="font-normal">
                                      {selected.apiBook.version !== '' ?
                                          " " + selected.apiBook.version
                                      :
                                          " 1. udgave"}
                                  </span>
                              </p>
                          </div>
                      </div>
                      <hr></hr>
                      <div className="flex-wrap gap-y-5 flex gap-x-10 items-start">
                          <div className="flex gap-x-10">
                              <div className="flex flex-col justify-between gap-1">
                                  <h1 className="text-sm sm:text-base">Pris</h1>
                                  <div className="h-full content-center">
                                      <p className="text-2xl lg:text-2xl font-bold select-none leading-none">{Number(selected.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                                  </div>
                              </div>
                              <div className="flex flex-col justify-between gap-1">
                                  <h1 className="text-sm sm:text-base">Stand</h1>
                                  <div className="h-full leading-none content-center">
                                      <h2 className="text-sm font-semibold uppercase hover:bg-pos-100 cursor-pointer bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 text-white w-fit px-4 py-1">{(typeof selected !== 'undefined') ? (selected.dbBook.stand === 1) ? "Meget brugt" : (selected.dbBook.stand === 2) ? "Lettere brugt" : "Som ny" : "Loading..."}</h2>
                                  </div>
                              </div>
                          </div>
                          {(selected.dbBook.desc !== '') ?
                              <div className="flex flex-col justify-between gap-1">
                                  <h1 className="text-sm sm:text-base">Beskrivelse</h1>
                                  <div className="h-full leading-none text-neutral-600 content-center">
                                      <p dangerouslySetInnerHTML={{
                                      __html: selected.dbBook.desc.replace(/\r\n/g, "<br />"),
                                      }} />
                                  </div>
                              </div>
                          :
                              ""
                          }
                      </div>
                      <hr></hr>
                      <div className="buttons flex gap-5 text-sm font-medium flex-wrap">
                        <div className={"border border-emerald-600 px-4 py-1 transition-[]" + (selected.dbBook.sold ? " opacity-50 select-none" : " cursor-pointer hover:bg-emerald-600 hover:text-white")} onClick={() => !selected.dbBook.sold ? navigate(`/dashboard/editBook?book=${selected.dbBook._id}`) : ""}>Rediger</div>
                        <div className={"border border-emerald-600 px-4 py-1 transition-[]" + (selected.dbBook.sold ? " opacity-50 select-none" : " cursor-pointer hover:bg-emerald-600 hover:text-white")} onClick={() => !selected.dbBook.sold ? deleteBook(selected.dbBook._id) : ""}>Slet</div>
                        {(!selected.dbBook.sold) ?
                          ""
                        :
                          <div className="border border-emerald-600 px-4 py-1 cursor-pointer hover:bg-emerald-600 hover:text-white transition-[]" onClick={() => selected.dbBook.sold ? navigate(`/dashboard/ordre?id=${selected.soldBook.dbShipment}`) : ""}>Detaljer</div>}
                      </div>
                    </div>
                </div>
              </div>
            :
                ""}
        </Modal>
    </div>
  )
}